import { Component, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { Image, StoreProjectFileInfo, ProjectFileNode } from '../../models/Image';
import { ImageService } from '../../services/image.service';
import { InstallationStoreData } from '../../models/installationstoredata';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '../../../Common/services/storage.service';
import { VerificationStore } from '../../models/verificationstore';
import { ImageVerificationStatus, VerificationMessage, VerificationStatus } from '../../../Common/Constants/data';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TreeNode, ConfirmationService } from 'primeng/api';
import { UserLogin } from '../../../Common/models/user.login';
import { MessageService } from '../../../project-intake/services/message.service';
import { CustomEncodeDecodeService } from '../../../Common/services/custom-encode-decode.service';
import { ProjectFile, StoreInfo } from '../../models/projectfile';
import { ProjectFileStoresInfo } from '../../models/projectfilestoresinfo';
import { Tree } from 'primeng/tree';
import { ProjectVerification } from '../../models/projectverification';
import { VerificationService } from '../../services/verification.service';

declare var $: any;

@Component({
  selector: 'app-image-card',
  templateUrl: './image-card.component.html',
  styleUrl: './image-card.component.css'
})
export class ImageCardComponent {
  vendorName?: string;
  vendorId: number = 0;

  orgID: number = 0;
  loggedInUserID: number = 0;
  projectId: number = 0;

  projectFileAllStoreData: ProjectFileStoresInfo[] = [];
  projectFileStoreData: ProjectFileStoresInfo[] = [];
  filteredprojectFileStoreData: ProjectFileStoresInfo[] = [];
  projectFilesStoresTreeNode: TreeNode[] = [];

  lstAllImages: Image[] = [];
  lstImages: Image[] = [];
  IsShowCountButton: boolean = true;
  currentImageIndex: number = 0;
  totalImagesByStore: number = 0;
  IsSkipImagesByValidationResponse: boolean = true;
  imageErrorMessage?: string;

  selectedNode: TreeNode | null = null;
  selectedInstallationStoreId: number = 0;
  selectedStoreName?: string;
  selectedReportDate?: string;
  selectedProjectFileId: number = 0;
  selectedImageId: number = 0;

  showPrevNavigator: boolean = false;
  showNextNavigator: boolean = true;

  navigationAction?: string;
  isAllStoresValidated: boolean = false;

  isFullScreen = false;
  @HostListener('document:fullscreenchange', ['$event'])
  fullscreenchange(event: KeyboardEvent) {
    if (!document.fullscreenElement) {
      this.isFullScreen = false;  // Exit fullscreen mode
    }
  }

  projectStatus?: string;
  isFullScreenStatus?: boolean;

  //isSaveOrClearResponses: boolean = false;
  isSaveResponses: number = 0;
  isClearResponses: number = 0;

  totalStores?: number;
  reviewedStores?: number;
  pendingStores?: number;

  @ViewChild('carousel') carousel: any;
  @ViewChild('treeComponent') treeComponent!: Tree;

  constructor(private route: ActivatedRoute, private imageService: ImageService,
    private storageService: StorageService, private ngxService: NgxUiLoaderService,
    private cdr: ChangeDetectorRef, private msgService: MessageService,
    private encodeDecodeService: CustomEncodeDecodeService, private verificationService: VerificationService,
    private confirmationService: ConfirmationService) {
  }

  async ngOnInit() {
    const projectIdParam = this.encodeDecodeService.decodeToInt(this.route.snapshot.paramMap.get('projectId'));

    let selectedVendor = this.storageService.getItem<any>("selectedVendor");
    this.vendorName = selectedVendor.vendorName;
    this.vendorId = selectedVendor.vendorID;

    this.getUserRoleInfo();

    if (projectIdParam !== null) {
      this.projectId = +projectIdParam;
    }
    else {
      this.projectId = 0;
    }

    if (this.projectId !== 0) {
      await this.getVerificationDetails();
      this.getProjectFilesWithInstallationStoreList();
    }
  }

  // User Role Info
  getUserRoleInfo() {
    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {
      let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
      this.orgID = userRoleInfo.orgID;
      this.loggedInUserID = userRoleInfo.userID;
    }
  }

  getProjectFilesWithInstallationStoreList() {
    this.ngxService.start();

    this.imageService.GetStoresForImagesByProjectFiles(this.projectId)
      .pipe(
        catchError(error => {
          this.ngxService.stop();
          console.error('Error fetching images:', error);
          return of([]); // Return an empty result to continue the stream
        })
      )
      .subscribe(projectFileStoredata => {
        this.projectFileAllStoreData = projectFileStoredata;
        this.projectFileStoreData = JSON.parse(JSON.stringify(this.projectFileAllStoreData));

        const treeData: TreeNode[] = this.mapToTreeNode(this.projectFileStoreData);
        this.projectFilesStoresTreeNode = treeData;

        // ===== Store Count Aggregation =====
        const allStoresFlat = this.projectFileStoreData
          .flatMap(pf => pf.stores)
          .filter((store, index, self) =>
            store && self.findIndex(s => s.installationStoreID === store.installationStoreID) === index
          ); // Get distinct stores by InstallationStoreID

        this.totalStores = allStoresFlat.length;
        this.reviewedStores = allStoresFlat.filter(s => s.isStoreValidated).length;
        this.pendingStores = this.totalStores - this.reviewedStores;

        // ===== Select the first pending store, if any =====
        const pendingValidationStore = this.getPendingValidationStore(this.projectFileStoreData);
        if (pendingValidationStore != null) {
          this.selectedInstallationStoreId = Number(pendingValidationStore.installationStoreID);
          this.selectedProjectFileId = Number(pendingValidationStore.projectFileID);
          this.setTreeNodeSelection();
        } else {
          this.isAllStoresValidated = true;
        }

        this.ngxService.stop();
      });
  }

  getVerificationDetails() {
    this.verificationService.GetProjectVerificationByProjectId(this.projectId)
      .pipe(
        catchError(error => {
          return of([]);
        })
      )
      .subscribe(projectVerificationdata => {
        this.projectStatus = projectVerificationdata.status;
      });
  }

  mapToTreeNode(data: any[]): TreeNode[] {
    return data.map((file, index) => ({
      key: file.projectFileID,
      label: file.createdDate,
      data: {
        projectFileID: file.projectFileID,
        filePath: file.filePath,
        status: file.status
      },
      expanded: index === 0 ? true : false,
      leaf: true,
      children: file.stores.map((store: StoreInfo) => ({
        key: store.installationStoreID + '/' + file.projectFileID,
        label: file.createdDate,
        storeLabel: store.storeNumber + ' - ' + store.storeName,
        //storeLabel: store.storeNumber,
        data: {
          installationStoreID: store.installationStoreID,
          storeID: store.storeID,
          storeLabel: store.storeNumber + ' - ' + store.storeName,
          label: store.storeNumber,
          isStoreValidated: store.isStoreValidated
        },
      }))
    }));
  }

  //If all Images are validated with the responses for the store, Need to get the next store
  getPendingValidationStore(projectFiles: ProjectFileStoresInfo[]) {
    for (const projectFile of projectFiles) {
      const pendingValidationStore = projectFile.stores.find(store => store.isStoreValidated === false);
      if (pendingValidationStore) {
        return {
          installationStoreID: pendingValidationStore.installationStoreID,
          projectFileID: projectFile.projectFileID
        };
      }
    }
    return null; // Return null if no invalid store is found
  }


  setTreeNodeSelection() {
    // Find the index of the selected project file (parent node)
    let fileIndex = this.projectFileStoreData.findIndex(f => f.projectFileID === Number(this.selectedProjectFileId));

    // Ensure the selected project file exists in the data
    const parentNode = this.projectFilesStoresTreeNode[fileIndex]; // parent node (project file)

    if (parentNode && parentNode.children && parentNode.children.length > 0) {
      // Find the index of the selected store (child node) within the project file
      const currentStoreIndex = parentNode.children.findIndex(store => store.data.installationStoreID === this.selectedInstallationStoreId);

      // If both parent and child nodes exist, select the child (store) node
      if (currentStoreIndex >= 0) {
        this.selectedNode = parentNode.children[currentStoreIndex]; // child node (store)
        this.nodeSelect({ node: this.selectedNode });
      }
    }
  }

  //Event for Node Selection in treeview
  nodeSelect(event: any, isUISelection: boolean = false) {

    const selectedNode = event.node;

    // Check if it's a leaf node (child)
    if (!selectedNode.leaf) {

      if (selectedNode.data.isStoreValidated && this.IsSkipImagesByValidationResponse) {
        this.selectedNode = null; // Cancel the selection
        return;
      }

      this.selectedNode = selectedNode;
      this.selectedInstallationStoreId = Number(selectedNode.key.split('/')[0]);
      this.selectedProjectFileId = Number(selectedNode.key.split('/')[1]);
      this.selectedReportDate = selectedNode.label;
      this.selectedStoreName = selectedNode.data.storeLabel;

      //Set currentImageIndex = 0 for the Treeview selection not for the navigator buttons
      if (isUISelection) {
        this.setCurrentImageIndex(0);
      }

      // Load images and assign values based on selected node data
      this.loadImages();

    } else {
      
    }

    this.scrollToSelectedNode();
  }

  // Scroll to the selected node
  scrollToSelectedNode() {
    setTimeout(() => {
      const selectedIndex = this.getNodeIndex(this.projectFilesStoresTreeNode, this.selectedNode);

      if (selectedIndex !== -1) {
        const scrollContainer = this.treeComponent.el.nativeElement.querySelector('.p-scroller');

        if (scrollContainer) {
          const scrollTop = selectedIndex * 46; // Adjust based on the size of each item
          scrollContainer.scrollTop = scrollTop;
        }
      }
    }, 100); // Wait for the DOM to update after filtering or selection
  }

  // Recursively find the index of the selected node
  getNodeIndex(nodes: any[], selectedNode: any, currentIndex = 0): number {
    for (let node of nodes) {
      if (node === selectedNode) {
        return currentIndex;
      }
      if (node.children && node.children.length > 0) {
        const childIndex = this.getNodeIndex(node.children, selectedNode, currentIndex + 1);
        if (childIndex !== -1) {
          return childIndex;
        }
      }
      currentIndex++;
    }
    return -1;
  }

  //Get the images by the InstallationStoreID, ProjectFileID
  loadImages() {
    this.imageService.GetImages(this.projectId, this.selectedInstallationStoreId, this.selectedProjectFileId)
      .pipe(
        catchError(error => {
          this.ngxService.stop();
          console.error('Error fetching images:', error);
          return of([]); // Return an empty result to continue the stream
        })
      )
      .subscribe(imagedata => {
        this.lstImages = [];
        this.lstAllImages = imagedata;
        this.lstImages = JSON.parse(JSON.stringify(this.lstAllImages));

        if (this.lstImages && this.lstImages.length > 0) {

          if (this.IsSkipImagesByValidationResponse) {
            this.lstImages = this.lstAllImages.filter(x => !x.isValidationResponseAdded);
          }

          this.selectedImageId = this.lstImages[this.currentImageIndex].imageID!;
          this.setTotalImageCount();
          this.setNavigatorDisableStatus();
        }
        this.ngxService.stop();

      });
  }

  setCurrentImageIndex(currentIndex: number) {
    this.currentImageIndex = currentIndex;
  }

  setTotalImageCount() {
    this.totalImagesByStore = this.lstImages.length;
  }

  setNavigatorDisableStatus() {
    // Use filtered or unfiltered project file data
    let fileData = this.filteredprojectFileStoreData != null && this.filteredprojectFileStoreData.length > 0 ? this.filteredprojectFileStoreData : this.projectFileStoreData;

    // Find the current project file based on selectedProjectFileId
    let fileIndex = fileData.findIndex(f => f.projectFileID === Number(this.selectedProjectFileId));

    // Find the current store within the selected project file
    const currentStoreIndex = fileData[fileIndex].stores.findIndex(store => store.installationStoreID === Number(this.selectedInstallationStoreId));

    // Find the current image in the image list
    const currentImageIndex = this.lstImages.findIndex(i => i.imageID === this.selectedImageId);

    // Disable the previous navigator if at the first file, store, and image
    if (fileIndex == 0 && currentStoreIndex == 0 && currentImageIndex == 0) {
      this.showPrevNavigator = false;
    } else {
      this.showPrevNavigator = true;
    }

    // Disable the next navigator if at the last file, last store, and last image
    if (
      fileIndex == fileData.length - 1 &&
      currentStoreIndex == fileData[fileIndex].stores.length - 1 &&
      currentImageIndex == this.lstImages.length - 1
    ) {
      this.showNextNavigator = false;
    } else {
      this.showNextNavigator = true;
    }
  }

  // Custom navigation: Previous
  navigatePrevious() {
    this.navigationAction = "Prev";

    const isFirstImage = this.currentImageIndex === 0;

    if (isFirstImage && this.navigationAction == "Prev") {
      let storeData = this.filteredprojectFileStoreData != null && this.filteredprojectFileStoreData.length > 0 ? this.filteredprojectFileStoreData : this.projectFileStoreData;
      const prevFile = this.getPreviousProjectFileAndStore(storeData, Number(this.selectedProjectFileId), Number(this.selectedInstallationStoreId));

      if (prevFile) {
        this.selectedProjectFileId = prevFile.projectFileID ?? 0;
        this.selectedInstallationStoreId = prevFile.installationStoreID ?? 0;
        this.setTreeNodeSelection();
      } else {
        return;
      }
    }
    else {
      const previousIndex = this.currentImageIndex > 0 ? this.currentImageIndex - 1 : this.lstImages.length - 1;
      //carousel.page = previousIndex;
      this.setCurrentImageIndex(previousIndex);
    }

    this.selectedImageId = this.lstImages[this.currentImageIndex]?.imageID ?? 0;
    this.setNavigatorDisableStatus();
  }

  // Custom navigation: Next
  navigateNext() {
    this.navigationAction = "Next";

    const isLastImage = this.currentImageIndex === this.lstImages.length - 1;

    if (isLastImage && this.navigationAction == "Next") {
      let storeData = this.filteredprojectFileStoreData != null && this.filteredprojectFileStoreData.length > 0 ? this.filteredprojectFileStoreData : this.projectFileStoreData;
      const nextFile = this.getNextProjectFileAndStore(storeData, Number(this.selectedProjectFileId), Number(this.selectedInstallationStoreId));

      if (nextFile) {
        this.selectedProjectFileId = nextFile.projectFileID ?? 0;
        this.selectedInstallationStoreId = nextFile.installationStoreID ?? 0;
        this.setTreeNodeSelection();
      } else {
        return;
      }
    }

    const nextIndex = this.currentImageIndex < this.lstImages.length - 1 ? this.currentImageIndex + 1 : 0;
    //carousel.page = nextIndex;
    this.setCurrentImageIndex(nextIndex);
    this.selectedImageId = this.lstImages[this.currentImageIndex]?.imageID ?? 0;
    this.setNavigatorDisableStatus();
  }

  getNextProjectFileAndStore(files: ProjectFileStoresInfo[], currentProjectFileID: number, currentInstallationStoreID: number) {
    return this.getAdjacentProjectFile(files, currentProjectFileID, currentInstallationStoreID, true);
  }

  getPreviousProjectFileAndStore(files: ProjectFileStoresInfo[], currentProjectFileID: number, currentInstallationStoreID: number) {
    return this.getAdjacentProjectFile(files, currentProjectFileID, currentInstallationStoreID, false);
  }

  getAdjacentProjectFile(files: ProjectFileStoresInfo[], currentProjectFileID: number, currentInstallationStoreID: number, isNext: boolean) {
    const fileIndex = files.findIndex(f => f.projectFileID === currentProjectFileID);
    const projectFile = files[fileIndex];

    if (projectFile) {
      // Find the current store within the project file
      let currentStoreIndex = projectFile.stores.findIndex(s => s.installationStoreID === currentInstallationStoreID);
      let adjacentStoreIndex = isNext ? currentStoreIndex + 1 : currentStoreIndex - 1;

      // Function to check if a store should be skipped
      const shouldSkipStore = (store: StoreInfo) => store.isStoreValidated && this.IsSkipImagesByValidationResponse;

      // Search for the next/previous valid store in the current project file
      while (adjacentStoreIndex >= 0 && adjacentStoreIndex < projectFile.stores.length && shouldSkipStore(projectFile.stores[adjacentStoreIndex])) {
        adjacentStoreIndex = isNext ? adjacentStoreIndex + 1 : adjacentStoreIndex - 1;
      }

      // Check if adjacent store is within bounds and not skipped
      if (adjacentStoreIndex >= 0 && adjacentStoreIndex < projectFile.stores.length) {
        return {
          installationStoreID: projectFile.stores[adjacentStoreIndex].installationStoreID,
          projectFileID: projectFile.projectFileID
        };
      }

      // Move to the next or previous project file if necessary
      let adjacentFileIndex = isNext ? fileIndex + 1 : fileIndex - 1;
      while (adjacentFileIndex >= 0 && adjacentFileIndex < files.length) {
        const adjacentFile = files[adjacentFileIndex];

        // Find the first or last valid store in the adjacent project file
        let validStoreIndex = isNext ? 0 : adjacentFile.stores.length - 1;
        while (validStoreIndex >= 0 && validStoreIndex < adjacentFile.stores.length && shouldSkipStore(adjacentFile.stores[validStoreIndex])) {
          validStoreIndex = isNext ? validStoreIndex + 1 : validStoreIndex - 1;
        }

        if (validStoreIndex >= 0 && validStoreIndex < adjacentFile.stores.length) {
          return {
            installationStoreID: adjacentFile.stores[validStoreIndex].installationStoreID,
            projectFileID: adjacentFile.projectFileID
          };
        }

        adjacentFileIndex = isNext ? adjacentFileIndex + 1 : adjacentFileIndex - 1;
      }
    }

    return null;
  }

  // Get the filter values
  handleFilter(event: any) {
    if (event.filteredValue) {
      const objFilteredValue = event.filteredValue;

      // Extract distinct installationStoreIDs
      const installationStoreIDs = [...new Set(
        objFilteredValue.flatMap((item: TreeNode) =>
          item.children?.map(child => child.data.installationStoreID)
        )
      )];

      this.filteredprojectFileStoreData = this.projectFileStoreData
        .map(projectFile => ({
          ...projectFile,
          stores: projectFile.stores.filter(store => installationStoreIDs.includes(store.installationStoreID))
        }))
        .filter(projectFile => projectFile.stores.length > 0);

    } else {
      this.filteredprojectFileStoreData = []; // Reset filtered data if no filter is applied
    }

    // Call the scroll method after the filtering is done
    setTimeout(() => {
      this.scrollToSelectedNode();
    }, 100); // Adding a small delay to ensure the filter has been applied and the DOM has updated
  }

  async skipImages(event: any) {

    var target = event.target;
    if (target.checked && this.lstImages && this.lstImages.length > 0) {
      this.lstImages = this.lstAllImages.filter(x => !x.isValidationResponseAdded);

      //When we are clicking SKIP IMAGES WITH RESPONSE = true while the store is already validated
      //Need to reload
      if (this.lstImages != null && this.lstImages.length == 0) {
        this.getProjectFilesWithInstallationStoreList();
      }
    }
    else {
      //Show all images
      this.lstImages = this.lstAllImages;
      this.isAllStoresValidated = false;
    }

    if (this.lstImages && this.lstImages.length > 0) {
      this.setCurrentImageIndex(0);
      this.selectedImageId = this.lstImages[this.currentImageIndex].imageID!;
      this.setTotalImageCount();
      this.setNavigatorDisableStatus();
    }
  }

  openImageInNewTab() {
    const elem = document.getElementById('divCarouselView') as HTMLElement;

    if (elem) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if ((elem as any).webkitRequestFullscreen) { // Safari compatibility
        (elem as any).webkitRequestFullscreen();
      } else if ((elem as any).mozRequestFullScreen) { // Firefox compatibility
        (elem as any).mozRequestFullScreen();
      } else if ((elem as any).msRequestFullscreen) { // IE/Edge compatibility
        (elem as any).msRequestFullscreen();
      }
      this.isFullScreen = true;  // Set the flag when fullscreen is opened
    } else {
      console.error('Element with ID "divCarouselView" not found.');
    }
  }

  exitFullScreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen().then(() => {
        this.isFullScreen = false;  // Reset the flag after exiting fullscreen
      }).catch((err) => {
        console.error('Error exiting fullscreen:', err);
      });
    } else if ((document as any).webkitExitFullscreen) { // Safari
      (document as any).webkitExitFullscreen();
      this.isFullScreen = false;
    } else if ((document as any).mozCancelFullScreen) { // Firefox
      (document as any).mozCancelFullScreen();
      this.isFullScreen = false;
    } else if ((document as any).msExitFullscreen) { // IE/Edge
      (document as any).msExitFullscreen();
      this.isFullScreen = false;
    }
  }

  // Method to handle save completion event from the child
  onSaveValidationCriteriaReponsesCompleted() {
    this.updateProjectFileStoresInfoObject('Save');
    setTimeout(() => {
      this.isSaveResponses += 1;
    }, 0);

    //this.navigateNext(this.carousel);
    this.navigateNext();
  }

  onClearValidationCriteriaReponsesCompleted() {
    this.updateProjectFileStoresInfoObject('Clear');
    setTimeout(() => {
      this.isClearResponses += 1;
    }, 0);
  }

  updateProjectFileStoresInfoObject_forImages(action: 'Save' | 'Clear') {

    // Find the image by imageID
    const imageToUpdate = this.lstImages.find(image => image.imageID === this.selectedImageId);

    // If an image is found, update the isValidationResponseAdded flag based on the action (Save or Clear)
    if (imageToUpdate) {
      if (action === 'Save') {
        imageToUpdate.isValidationResponseAdded = true;
      } else if (action === 'Clear') {
        imageToUpdate.isValidationResponseAdded = false;
      }
    }

    // Check if all images in lstImages have isValidationResponseAdded set to true
    const allImagesValidated = this.lstImages.every(image => image.isValidationResponseAdded === true);

    // If all images are validated, set isStoreValidated to true, otherwise set it to false
    let isStoreValidated = allImagesValidated;

    // Find the index of the selected project file (parent node)
    let fileIndex = this.projectFileStoreData.findIndex(f => f.projectFileID === Number(this.selectedProjectFileId));

    // Ensure the selected project file exists in the data
    const parentNode = this.projectFilesStoresTreeNode[fileIndex]; // parent node (project file)

    if (parentNode && parentNode.children && parentNode.children.length > 0) {
      // Find the index of the selected store (child node) within the project file
      const currentStoreIndex = parentNode.children.findIndex(store => store.data.installationStoreID === Number(this.selectedInstallationStoreId));

      if (currentStoreIndex >= 0) {
        // Update the isStoreValidated flag based on the image validation status
        parentNode.children[currentStoreIndex].data.isStoreValidated = isStoreValidated;
      }
    }

    const projFile = this.projectFileStoreData[fileIndex];
    if (projFile && projFile.stores.length > 0) {
      const currentStoreIndex = projFile.stores.findIndex(store => store.installationStoreID === Number(this.selectedInstallationStoreId));

      if (currentStoreIndex >= 0) {
        // Update the isStoreValidated flag in the projectFileStoreData based on the image validation status
        this.projectFileStoreData[fileIndex].stores[currentStoreIndex].isStoreValidated = isStoreValidated;
      }
    }
  }

  updateProjectFileStoresInfoObject(action: 'Save' | 'Clear'): void {
    const selectedProjectFileId = Number(this.selectedProjectFileId);
    const selectedInstallationStoreId = Number(this.selectedInstallationStoreId);

    this.updateImageValidationFlag(action);
    const allImagesValidated = this.areAllImagesValidated();

    const fileIndex = this.getProjectFileIndex(selectedProjectFileId);
    const isDuplicateStore = this.isStoreDuplicate(selectedProjectFileId, selectedInstallationStoreId);
    const latestProjectFileId = this.getLatestProjectFileId();

    if (isDuplicateStore) {
      if (latestProjectFileId === selectedProjectFileId) {
        this.setStoreValidationForAllFiles(selectedInstallationStoreId, allImagesValidated);
        this.updateStoreCounts();
      }
      else {
        this.setStoreValidationForSingleFile(fileIndex, selectedInstallationStoreId, false);
        this.updateStoreCounts();
      }
    } else {
      this.setStoreValidationForSingleFile(fileIndex, selectedInstallationStoreId, allImagesValidated);
      this.updateStoreCounts();
    }
  }

  // --- Helper Methods ---
  private updateImageValidationFlag(action: 'Save' | 'Clear'): void {
    const imageToUpdate = this.lstImages.find(img => img.imageID === this.selectedImageId);
    if (imageToUpdate) {
      imageToUpdate.isValidationResponseAdded = (action === 'Save');
    }
  }

  private areAllImagesValidated(): boolean {
    return this.lstImages.every(img => img.isValidationResponseAdded === true);
  }

  private getProjectFileIndex(projectFileId: number): number {
    return this.projectFileStoreData.findIndex(f => f.projectFileID === projectFileId);
  }

  private isStoreDuplicate(projectFileId: number, storeId: number): boolean {
    const projFile = this.projectFileStoreData.find(f => f.projectFileID === projectFileId);
    const store = projFile?.stores.find(s => s.installationStoreID === storeId);
    return store?.isDuplicateStore ?? false;
  }

  private getLatestProjectFileId(): number {
    return Math.max(...this.projectFileStoreData.map(f => f.projectFileID));
  }

  private setStoreValidationForAllFiles(storeId: number, validated: boolean): void {
    this.projectFilesStoresTreeNode.forEach(projectFile =>
      projectFile.children?.forEach(storeNode => {
        if (storeNode.data.installationStoreID === storeId) {
          storeNode.data.isStoreValidated = validated;
        }
      })
    );

    this.projectFileStoreData.forEach(file =>
      file.stores?.forEach(store => {
        if (store.installationStoreID === storeId) {
          store.isStoreValidated = validated;
        }
      })
    );
  }

  private setStoreValidationForSingleFile(fileIndex: number, storeId: number, validated: boolean): void {
    const parentNode = this.projectFilesStoresTreeNode[fileIndex];
    const projFile = this.projectFileStoreData[fileIndex];

    const updateTreeNode = (): void => {
      const storeNode = parentNode?.children?.find(child => child.data.installationStoreID === storeId);
      if (storeNode) {
        storeNode.data.isStoreValidated = validated;
      }
    };

    const updateStoreData = (): void => {
      const store = projFile?.stores.find(s => s.installationStoreID === storeId);
      if (store) {
        store.isStoreValidated = validated;
      }
    };

    updateTreeNode();
    updateStoreData();
  }

  private updateStoreCounts(): void {
    const allStoresFlat = this.projectFileStoreData
      .flatMap(pf => pf.stores)
      .filter((store, index, self) =>
        store && self.findIndex(s => s.installationStoreID === store.installationStoreID) === index
      ); // Deduplicate by installationStoreID

    this.totalStores = allStoresFlat.length;
    this.reviewedStores = allStoresFlat.filter(s => s.isStoreValidated).length;
    this.pendingStores = this.totalStores - this.reviewedStores;
  }

  UpdateVerificationStatus(projectVerificationdata: ProjectVerification, isCompleteVerification: boolean = false) {
    this.verificationService.UpdateProjectVerificationStatus(projectVerificationdata)
      .pipe(
        catchError(error => {
          console.error('Error Updating status:', error);
          return of(false);
        })
      )
      .subscribe(x => {
        if (x && isCompleteVerification) {
          this.msgService.htmlSuccess(VerificationMessage.PROJECT_VERIFICATION_SUCCESS);
        }
      });
  }

  getPendingImagesCount() {
    this.ngxService.start();
    this.imageService.GetPendingImageCount(this.projectId)
      .pipe(
        catchError(error => {
          this.ngxService.stop();
          console.error('Error fetching images:', error);
          return of([]); // Return an empty result to continue the stream
        })
      )
      .subscribe(pendingImageCountData => {

        if (pendingImageCountData.filter(x => !x.isAllImagesVerified).length > 0) {

          const messageHeader = 'Below are the no of images still pending for verification. Are you sure to complete the verification?';

          let tableRows = pendingImageCountData.map(item => {
            return `
              <tr>
                <td class="table-row center-align" style="text-align: center;">${item.createdDate}</td>
                <td class="table-row center-align" style="text-align: center;">${item.pendingImages}</td>
              </tr>
            `;
          }).join('');

          const tableStructure = `
      <table class="table datatablePendingImages border-x-0 mb-4" style="width: 100%;">
        <thead>
          <tr class="subheaderrr">
            <th class="py-1" width="30%">Report Date</th>
            <th width="20%" class="border-end-0">Count</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
        </tbody>
      </table>
    `;

          this.confirmationService.confirm({
            message: `${messageHeader}<br><br>${tableStructure}`,
            header: 'Pending Verification',
            icon: 'pi pi-info-circle',
            accept: () => {
              let projectVerificationdata: ProjectVerification = new ProjectVerification();
              projectVerificationdata.projectID = this.projectId;
              projectVerificationdata.status = VerificationStatus.VERIFIED;
              projectVerificationdata.changedBy = this.loggedInUserID;
              this.UpdateVerificationStatus(projectVerificationdata, true);
              this.projectStatus = VerificationStatus.VERIFIED;
            },
            reject: () => {
            }
          });

        }
        else {

          this.confirmationService.confirm({
            header: VerificationMessage.PROJECT_VERIFICATION_CONFIRMATION_HEADER,
            icon: 'pi pi-exclamation-triangle',
            message: VerificationMessage.PROJECT_VERIFICATION_CONFIRMATION,
            accept: () => {
              let projectVerificationdata: ProjectVerification = new ProjectVerification();
              projectVerificationdata.projectID = this.projectId;
              projectVerificationdata.status = VerificationStatus.VERIFIED;
              projectVerificationdata.changedBy = this.loggedInUserID;
              this.UpdateVerificationStatus(projectVerificationdata, true);
              this.projectStatus = VerificationStatus.VERIFIED;
            },
            reject: () => {
            }
          });
        }

        this.ngxService.stop();

      });
  }

  async UpdateVerificationCompleteStatus(projectId: number) {
    await this.getPendingStoreCount();
  }

  getPendingStoreCount() {
    const projectFileStoreData = this.projectFileStoreData;

    const storeMap = new Map<number, { store: any; projectFileID: number }>();

    // Flatten all stores & handle duplicates
    for (const pf of projectFileStoreData) {
      for (const store of pf.stores) {
        const storeID = store.storeID;
        const projectFileID = pf.projectFileID;

        if (storeID != null) {
          // If duplicate exists, keep only latest projectFileID
          if (!storeMap.has(storeID) || storeMap.get(storeID)!.projectFileID < projectFileID) {
            storeMap.set(storeID, { store, projectFileID });
          }
        } else {
          // If storeID is null, use installationStoreID as unique fallback
          storeMap.set(store.installationStoreID, { store, projectFileID });
        }
      }
    }

    // Filter for only unvalidated (pending) stores
    const pendingStores = Array.from(storeMap.values()).filter(x => !x.store.isStoreValidated);

    // Group by ProjectFileID
    const pendingCountByProjectFile: { [projectFileID: number]: number } = {};

    for (const entry of pendingStores) {
      const pfId = entry.projectFileID;
      pendingCountByProjectFile[pfId] = (pendingCountByProjectFile[pfId] || 0) + 1;
    }

    const pendingStoreCountData = Object.entries(pendingCountByProjectFile).map(([projectFileID, count]) => {
      const pf = projectFileStoreData.find(p => p.projectFileID === +projectFileID);

      return {
        projectFileID: +projectFileID,
        pendingCount: count,
        createdDate: pf?.createdDate || null
      };
    });

    if (pendingStoreCountData.filter(x => x.pendingCount > 0).length > 0) {

      const messageHeader = 'Below are the number of stores still pending for verification. Are you sure you want to complete the verification?';

      let tableRows = pendingStoreCountData
        .filter(x => x.pendingCount > 0)
        .sort((a, b) => b.projectFileID - a.projectFileID)
        .map(item => `
        <tr>
          <td class="table-row center-align" style="text-align: center;">${item.createdDate}</td>
          <td class="table-row center-align" style="text-align: center;">${item.pendingCount}</td>
        </tr>
    `).join('');

      const tableStructure = `
    <table class="table datatablePendingImages border-x-0 mb-4" style="width: 100%;">
      <thead>
        <tr class="subheaderrr">
          <th class="py-1" width="30%">Report Date</th>
          <th width="20%" class="border-end-0">Pending Count</th>
        </tr>
      </thead>
      <tbody>
        ${tableRows}
      </tbody>
    </table>
  `;

      this.confirmationService.confirm({
        message: `${messageHeader}<br><br>${tableStructure}`,
        header: 'Pending Verification',
        icon: 'pi pi-info-circle',
        accept: () => {
          let projectVerificationdata: ProjectVerification = new ProjectVerification();
          projectVerificationdata.projectID = this.projectId;
          projectVerificationdata.status = VerificationStatus.VERIFIED;
          projectVerificationdata.changedBy = this.loggedInUserID;
          this.UpdateVerificationStatus(projectVerificationdata, true);
          this.projectStatus = VerificationStatus.VERIFIED;
        },
        reject: () => { }
      });

    } else {

      this.confirmationService.confirm({
        header: VerificationMessage.PROJECT_VERIFICATION_CONFIRMATION_HEADER,
        icon: 'pi pi-exclamation-triangle',
        message: VerificationMessage.PROJECT_VERIFICATION_CONFIRMATION,
        accept: () => {
          let projectVerificationdata: ProjectVerification = new ProjectVerification();
          projectVerificationdata.projectID = this.projectId;
          projectVerificationdata.status = VerificationStatus.VERIFIED;
          projectVerificationdata.changedBy = this.loggedInUserID;
          this.UpdateVerificationStatus(projectVerificationdata, true);
          this.projectStatus = VerificationStatus.VERIFIED;
        },
        reject: () => { }
      });

    }

  }
}